import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./app/App";
import store from "./store/configureStore";
import * as serviceWorker from "./serviceWorker";

require("bootstrap");

ReactDOM.render(<App store={store} />, document.getElementById("root"));

// Enable hot module replacement for all modules.
if (module.hot) {
  module.hot.accept();
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
